import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/_app/runs/$id/")({
  parseParams: (params) => {
    return { id: z.coerce.number().parse(params.id) };
  },
});
